import { createApp } from 'vue'
import compareApp from './compareApp.vue'
import store from './store'

createApp(compareApp).use(store).mount('#compareApp')
